<template>
  <div class="auth-page-container">
    <h2 class="auth-page-title font-500">
      {{ $t('pagelayout.mse-transaction') }}
    </h2>
    <section class="auth-page-section">
      <b-form v-show="true" @submit.prevent="search" class="mx-2">
        <b-row>
          <div class="col">
            <div class="row mb-ten">
              <date-picker
                :max-date="new Date()"
                :min-date="minDate"
                @change="dateChange"
                range
                :datesProp="initialDates"
                class="mr-3"
              />
              <ic-button size="tn" type="submit" class="card-button mt-0">
                {{ $t('helper.search') }}
              </ic-button>
            </div>
          </div>
          <div class="col-md-auto">
            <div class="row">
              <ic-button
                size="tn"
                @click="printList"
                type="button"
                class="grey"
              >
                <i class="fas fa-download mr-2" />
                {{ $t('helper.save') }}
              </ic-button>
            </div>
          </div>
        </b-row>
      </b-form>
      <div class="table-container">
        <table class="ic-table">
          <thead>
            <tr>
              <th>№</th>
              <th>{{ $t('mcsd.transaction_date') }}</th>
              <th>{{ $t('mcsd.securities_name') }}</th>
              <th>{{ $t('mcsd.transaction_type_name') }}</th>
              <th class="right">{{ $t('mcsd.per_price') }}</th>
              <th class="right">{{ $t('mcsd.securities_quantity') }}</th>
              <th class="right">{{ $t('mcsd.commission') }}</th>
              <th>{{ $t('mcsd.description') }}</th>
              <th>{{ $t('mcsd.additional') }}</th>
            </tr>
          </thead>
          <tbody v-if="items && items.length">
            <tr v-for="(item, i) in items" :key="`transaction${i}`">
              <td>{{ i + 1 }}</td>
              <td>{{ item.transaction_date }}</td>
              <td>{{ item.securities_name }}</td>
              <td>{{ item.transaction_type_name }}</td>
              <td class="right">{{ item.per_price | currency('', '₮') }}</td>
              <td class="right">{{ item.securities_quantity | currency('','') }}</td>
              <td class="right">{{ item.commission | currency('', '₮') }}</td>
              <td>{{ item.description }}</td>
              <td>{{ item.additional && item.additional !== '0' ? item.additional : '-' }}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="5">
                {{
                  $t('helper.not-found-slot', {
                    slot: $tc('account.statement', 1),
                  })
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <b-pagination-nav
        v-if="items && items.length"
        align="center"
        v-model="page.number"
        class="pt-4"
        use-router
        :link-gen="linkGen"
        :number-of-pages="page.totalPages || 1"
      />
    </section>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { downloadCsvRecord } from '../../utils/functions'
import api from '../../api/stoTrade'
import DatePicker from '../../components/DatePicker'
import moment from 'moment'

export default {
  name: 'mseTransactionView',
  components: {
    DatePicker,
  },
  data() {
    const initial = {
      start: moment().subtract(90, 'days').toDate(),
      end: new Date(),
    }
    return {
      minDate: moment().subtract(100, 'months').toDate(),
      initialDates: initial,
      isLoading: false,
      page: {
        number: 1,
        totalPages: 1,
      },
      items: [],
      brands: [],
      filters: {
        from: moment(initial.start).format('YYYY-MM-DD'),
        to: moment(initial.end).format('YYYY-MM-DD'),
      },
    }
  },
  mounted() {
    this.fetchData()
  },
  computed: {
    ...mapState('common', ['dark']),
  },
  methods: {
    dateChange({ start, end }) {
      if (start && end) {
        this.filters.from = moment(start).format('YYYY-MM-DD')
        this.filters.to = moment(end).format('YYYY-MM-DD')
        this.page.number = 1
        this.totalPages = 1
      }
    },
    linkGen(page) {
      const query = { ...this.$route.query }
      if (!query.page && page === 1) {
        return { query }
      }
      query.page = page
      return { query }
    },
    async fetchData() {
      this.isLoading = true
      try {
        const { data } = await api.getUserFinalities({
          from: this.filters.from,
          to: this.filters.to,
          page: this.$route.query.page,
        })
        this.page = {
          totalPages: data.last_page,
          number: data.current_page,
        }
        this.items = data.data
      } catch (e) {
        console.error(e)
      }
      this.isLoading = false
    },
    search() {
      const query = _.pickBy(this.filters, (v) => !_.isEmpty(v) || !!v)
      this.$router.push({ query })
    },
    queryHandler() {
      this.filters = { ...this.filters, ...this.$route.query }
      return _.pickBy(this.filters, (v) => !_.isEmpty(v) || !!v)
    },
    async printList() {
      const { data } = await api.getUserFinalitiesNonPage({
        from: this.filters.from,
        to: this.filters.to,
      })
      console.log(data)
      data.forEach((e) => {
        e.securities_name = e.securities_name.replace(/,/g, ' ');
        e.description = e.description.replace(/,/g, ' ');
        e.additional = (e.additional && e.additional !== '0') ? e.additional.replace(/,/g, '') : '-';
      })
      downloadCsvRecord(
        data,
        [
          'transaction_date',
          'securities_name',
          'transaction_type_name',
          'per_price',
          'securities_quantity',
          'commission',
          'description',
          'additional',
        ],
        'mcsd_transactions',
          [
              'Огноо',
              'Симбол',
              'Төрөл',
              'Нэгжийн үнэ',
              'Ширхэг/Мөнгөн дүн',
              'Шимтгэл',
              'Тайлбар',
              'Нэмэлт мэдээлэл'
          ]
      )
    },
  },
  watch: {
    '$route.query': {
      handler: 'fetchData',
      deep: true,
    },
  },
}
</script>

<style scoped>
.collapse-btn {
  border-radius: 25px;
}
.collapse-btn:disabled {
  color: #5e5e5e;
  background-color: #ddd;
  border-color: #eee;
  cursor: not-allowed;
}
</style>

<style lang="scss" src="../../../sass/partials/sidebar-submenu.scss"></style>
